import { useState } from "react";
import VerticalOurWork from "./VerticalOurWork";
import HorizontalOurWork from "./HorizontalOurWork";

export default function SeplourWork() {
  const [mode, setMode] = useState("vertical");
  const [activeIndex, setActiveIndex] = useState(0);

  const handleImageClick = (index) => {
    setActiveIndex(index);
    setMode("horizontal");
  };

  const handleBack = () => {
    setMode("vertical");
  };

  return (
    <>
      {mode === "vertical" && (
        <VerticalOurWork onImageClick={handleImageClick} />
      )}

      {mode === "horizontal" && (
        <HorizontalOurWork activeIndex={activeIndex} onBack={handleBack} />
      )}
    </>
  );
}
